import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "admins",
  initialState: {
    list: [],
    selected: null,
    count: 0,
  },
  reducers: {
    setAdmins: (state, { payload: list }) => {
      return {
        ...state,
        list,
      };
    },
    countAdmins: (state, { payload: count }) => {
      return {
        ...state,
        count,
      };
    },
    selectAdmin: (state, { payload: selected }) => {
      return {
        ...state,
        selected,
      };
    },
    cancelSelectedAdmin: (state) => {
      return {
        ...state,
        selected: null,
      };
    },
  },
});

export const { setAdmins, countAdmins, selectAdmin, cancelSelectedAdmin } =
  slice.actions;

export default slice.reducer;

export const getAdminsSelector = (store) => store.admins.list;
export const getSelectedAdminSelector = (store) => store.admins.selected;
export const getAdminsCountSelector = (store) => store.admins.count;
